/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import 'typeface-public-sans';

export { wrapRootElement } from './wrapRootElement';

require('prismjs/themes/prism-solarizedlight.css');
